import type { CareerCenter } from "./types"

import { NIL } from "uuid"

export function isWwwCareerCenter(careerCenter: CareerCenter | undefined): boolean {
  return careerCenter?.id === NIL
}
